export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-edit-box-line',
      title: 'Client Posts a Need',
      description: 'Homeowner or business describes their project requirements through our simple form or AI chat interface.',
      color: 'orange'
    },
    {
      number: '02',
      icon: 'ri-robot-2-line',
      title: 'AI Generates Job Listing',
      description: 'Our AI analyzes the request and creates a structured job listing with detailed scope, materials estimate, and budget range.',
      color: 'amber'
    },
    {
      number: '03',
      icon: 'ri-search-eye-line',
      title: 'Tradies Browse & Apply',
      description: 'Qualified tradies see the job in their feed, review AI-generated details, and submit proposals with their pricing and timeline.',
      color: 'orange'
    },
    {
      number: '04',
      icon: 'ri-hand-coin-line',
      title: 'Get Hired & Get Paid',
      description: 'Client reviews proposals, selects the best tradie, work gets done, and payment is processed securely through the platform.',
      color: 'amber'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-lightbulb-flash-line"></i>
            <span>Simple Process</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From job posting to payment, our AI-powered platform handles everything seamlessly
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-orange-200 to-amber-200 -translate-x-4"></div>
              )}

              <div className="relative bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 hover:shadow-lg transition-all">
                {/* Step Number */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-orange-600 to-amber-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className={`w-16 h-16 bg-${step.color}-100 rounded-xl flex items-center justify-center mb-4 mt-2`}>
                  <i className={`${step.icon} text-3xl text-${step.color}-600`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">Ready to start finding jobs or posting work?</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/signup"
              className="inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Join as Tradie</span>
              <i className="ri-user-add-line"></i>
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-all border-2 border-gray-200 whitespace-nowrap cursor-pointer"
            >
              <span>Post Your First Job</span>
              <i className="ri-add-circle-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}